import { InteractionStatus } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import RoutesEnum from '../../components/Routes/rootEnum'
import SpinnerBlock from '../../components/Spinner/SpinnerBlock'
import { POST_LOGIN_DEST_KEY, toSafeInternalPath } from './authRedirect'

// E8 F8-2 (story 8.2.1): the dedicated MSAL redirect reply route (the SPA app registration's only reply
// URL — INFRA ciam/main.tf). The redirect response is processed upstream in IdentityConfigLoader (with
// navigateToLoginRequestUrl:false, so the browser stays here rather than bouncing back to /login): on
// success it sets the active account and stashes the post-login destination (the origin-validated deep
// link, or '' for the plain dashboard case); on failure it stashes /login?error=login_failed. This page
// just waits for MSAL to settle and routes accordingly, so the user is never stranded here. (App marks the
// redux sign-in flag from the MSAL account once it renders — see App.tsx.)
const AuthCallbackPage = () => {
  const { instance, inProgress } = useMsal()
  const navigate = useNavigate()

  useEffect(() => {
    // Wait until MSAL has finished settling.
    if (inProgress !== InteractionStatus.None) {
      return
    }
    // A stashed destination means a redirect just completed — consume it once and route there (empty →
    // dashboard). Its presence, even empty, distinguishes "just signed in" from a manual/bookmark visit.
    const storedDest = sessionStorage.getItem(POST_LOGIN_DEST_KEY)
    if (storedDest !== null) {
      sessionStorage.removeItem(POST_LOGIN_DEST_KEY)
      navigate(toSafeInternalPath(storedDest) ?? RoutesEnum.DASHBOARD, { replace: true })
      return
    }
    // Manual visit / bookmark (no redirect in flight): resolve from the cached accounts so a returning
    // signed-in user reaches the dashboard and everyone else the login page.
    navigate(instance.getAllAccounts().length > 0 ? RoutesEnum.DASHBOARD : RoutesEnum.LOGIN, { replace: true })
  }, [inProgress, instance, navigate])

  return <SpinnerBlock />
}

export default AuthCallbackPage
